
import React, { useEffect, useState } from 'react'
import { Form, Button, Tab, Tabs } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import 'react-perfect-scrollbar/dist/css/styles.css';
import Table from 'react-bootstrap/Table';
import { ToastContainer, toast } from 'react-toastify';
import { LuFileEdit, LuTrash2 } from 'react-icons/lu'
import Swal from 'sweetalert2'
import Loader from '../../component/loader/Loader'
import { addCartOrderRes, addCartOrderTodo } from '../../redux/Slices/Orders/AddCartOrder'
import { Formik, useFormik } from 'formik'
import debounce from "lodash/debounce"
import { useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { CityListRes, CityListTodo } from '../../redux/Slices/Orders/CityList'
import { DispatchSchema } from './DispatchValidation'
import { PendingAmtRes, PendingAmtTodo } from '../../redux/Slices/Orders/PendingAmt'
import { OrderDetailsRes, OrderDetailsTodo } from '../../redux/Slices/Orders/OrderDetails'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import moment from 'moment'
import { CategoryListTodo } from '../../redux/Slices/Category/CategoryList'
import AddItem from './AddItem'
import { DivisionListTodo } from '../../redux/Slices/Orders/DivisionList';
import { deleteItemTodo } from '../../redux/Slices/Items/ItemDelete';
import { itemListTodo } from '../../redux/Slices/Items/ItemList';



export default function AddOrder() {
    const dispatch = useDispatch()
    const { state } = useLocation()
    const OrderDetails = useSelector(state => state?.OrderDetails?.data?.data)
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [divisionId, setDivisionId] = useState('')
    const [divisionShortName, setDivisionShortName] = useState('')
    const [cityLoading, setCityLoading] = useState(false)
    const [orderItems, setOrderItems] = useState([])
    // const vpurchase_order_code = state?.vpurchase_order_code
    const customer_plant_code = state?.vcust_plant_code
    const cityList = useSelector(state => state?.CityList?.data?.data)
    const pendingAmt = useSelector(state => state?.PendingAmt?.data)
    const divisionTypeData = useSelector(state => state?.DivisionList?.data?.data)

    console.log("orderItems", orderItems)

    let mobileScreen = window.screen.width <= 992;

    const otherCity = { "value": 0, "label": "Other" }

    const city_option = cityList && cityList.map(val => (
        { "value": val.cit_id, "label": val.vcustomer_plant_city }
    ));

    const division_option = divisionTypeData?.map(val => (
        { "value": val.id, "label": val.vdivision_name, "short_name": val.vshort_name }
    ));

    const cust_typ_option = [
        { "value": "1", "label": "Customer" },
        { "value": "2", "label": "Distributer" }
    ]
    const so_typ_option = [
        { "value": "FOC", "label": "FOC" },
        { "value": "NO FOC", "label": "NO FOC" }
    ]

    const csale_typ_option = [
        { "value": "R", "label": "Regular" },
        { "value": "E", "label": "Export" }
    ]

    city_option?.push(otherCity);


    const handleModal = (data) => {
        setModal(true)
      
        // setData(detailsData)

    }

    const errorFun = () => {
        Swal.fire("Please Select Division !");
    }

    const load_city = debounce((e) => {
        if (e) {
            // console.log("city",e)
            setCityLoading(true)
            dispatch(CityListTodo(e)).then(() => city_res())
        }
    }, 500)

    const city_res = () => {
        if (CityListRes?.success) {
            setCityLoading(false)
        } else {
            setCityLoading(false)
        }
    }

    const navigate = useNavigate()

    const delete_items = (index) => {

        Swal.fire({
            title: "Item Remove",
            text: "Are You Sure Want To Remove This Item ?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Remove'
        }).then((result) => {
            if (result.isConfirmed) {
                setOrderItems(oldValues => {
                    return oldValues.filter((_, i) => i !== index)
                })
                Swal.fire(
                    "Item",
                    'Item Remove Successfully',
                    'success'
                )
            }

        })
    }

    const delete_Items2 = (data) => {
        dispatch(deleteItemTodo(data?.iitem_detail_id))
    }
    const initialValues = {
        name: OrderDetails?.vdespatach_name,
        address: OrderDetails?.vcustomer_address,
        city: OrderDetails?.hasOwnProperty('icity_id') && { value: OrderDetails?.icity_id, label: OrderDetails?.vdespatch_city },
        gst_no: OrderDetails?.vdespatach_gst_no,
        pin_code: OrderDetails?.vdespatach_pincode,
        city_name: OrderDetails?.vdespatch_city,
        cust_po_date: OrderDetails?.dpo_date,
        so_type: OrderDetails?.vso_type || 'NO FOC',
        customer_typ: state?.id ? OrderDetails?.icustomer_type_id : localStorage.getItem('icustomer_type_id'),
        csale_typ: OrderDetails?.csale_type || localStorage.getItem('csale_type'),
        cust_purchase_order: OrderDetails?.vcustomer_purchase_order,
        remark: '',
        file: '',
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: DispatchSchema,
        // validateOnMount: true,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            AddOrderItem()
            // console.log(values)
        }
    })

    const checkedFun = (e) => {

        if (e) {
            setCityLoading(true)
            setFieldValue('name', localStorage.getItem('vplant_name'))
            setFieldValue('address', `${localStorage.getItem('vcustomer_plant_address')} , ${localStorage.getItem('vcustomer_plant_city')}`)
            setFieldValue('gst_no', localStorage.getItem('vdespatach_gst_no'))
            setFieldValue('pin_code', localStorage.getItem('vdespatach_pincode'))
            setFieldValue('city_name', localStorage.getItem('vcustomer_plant_city'))
            setFieldValue('cust_po_date', new Date().toLocaleDateString('en-GB'))
            dispatch(CityListTodo(localStorage.getItem('vcustomer_plant_city'))).then((res) => {
                if (res?.payload?.success) {
                    setCityLoading(false)
                    setFieldValue('city', { value: localStorage.getItem('icity_id'), label: localStorage.getItem('vcustomer_plant_city') })
                }
            })
        } else {
            setCityLoading(false)
            setFieldValue('name', OrderDetails?.vdespatach_name || '')
            setFieldValue('address', OrderDetails?.vcustomer_address || '')
            setFieldValue('city', OrderDetails?.hasOwnProperty('icity_id') && { value: OrderDetails?.icity_id, label: OrderDetails?.vdespatch_city })
            setFieldValue('gst_no', OrderDetails?.vdespatach_gst_no || '')
            setFieldValue('pin_code', OrderDetails?.vdespatach_pincode || '')
            setFieldValue('city_name', OrderDetails?.vdes_city_name || '')
            setFieldValue('cust_po_date', OrderDetails?.dpo_date || '')
        }
    }
    // console.log(values, 'val')

    const AddOrderItem = () => {
        if (errors?.hasOwnProperty("name") ||
            errors?.hasOwnProperty("address") ||
            errors?.hasOwnProperty("gst_no") ||
            errors?.hasOwnProperty("city") ||
            errors?.hasOwnProperty("city_name") ||
            errors?.hasOwnProperty("pin_code") ||
            errors?.hasOwnProperty("cust_po_date")
            // errors?.hasOwnProperty("remark")
        ) {
            Swal.fire({
                title: "Order",
                text: 'All Filed Mandatory In Ship To Address',
                icon: "error"
            });
        } else {
            const newOrderItem = {
                vpurchase_order_code: OrderDetails?.vpurchase_order_code ? OrderDetails?.vpurchase_order_code : "",
                id: OrderDetails ? OrderDetails?.id : "0",
                vcust_plant_code: customer_plant_code ? customer_plant_code : localStorage.getItem('vcust_plant_code'),
                ctax_type: OrderDetails?.ctax_type ? OrderDetails?.ctax_type : localStorage.getItem('cTax_type'),
                ibusiness_area_id: OrderDetails?.ibusiness_area_id ? OrderDetails?.ibusiness_area_id : localStorage.getItem('ibusiness_area_id'),
                icurrency_id: OrderDetails?.icurrency_id ? OrderDetails?.icurrency_id : localStorage.getItem('icurrency_id'),
                mcurrency_rate: OrderDetails?.mcurrency_rate ? OrderDetails?.mcurrency_rate : "1",
                vdespatach_gst_no: values.gst_no,
                vdespatach_name: values.name,
                vdespatach_pincode: values.pin_code,
                dpo_date: values.cust_po_date ? values.cust_po_date : new Date().toISOString(),
                vso_type: values.so_type,
                csale_type: values.csale_typ,
                icustomer_type_id: values.customer_typ,
                vcustomer_purchase_order: values.cust_purchase_order,
                vdivision_short_name: OrderDetails?.vdivision_id ? OrderDetails?.vdivision_id : divisionShortName,
                idivision_id: OrderDetails?.idivision_id ? OrderDetails?.idivision_id : divisionId,
                icity_id: values.city.value,
                vdes_city_name: values.city_name,
                vcustomer_address: values.address,
                // vremark: values.remark,
                vdespatch_state: OrderDetails?.vdespatch_state ? OrderDetails?.vdespatch_state : localStorage.getItem('vship_to_state'),
                vbusiness_area_short_name: OrderDetails?.vbusiness_area_short_name ? OrderDetails?.vbusiness_area_short_name : localStorage.getItem('vbusiness_area_short_name'),
                vsales_person_code: OrderDetails?.vsales_person_code ? OrderDetails?.vsales_person_code : "",
                update_master: '0',
                fin_year: localStorage.getItem('vfin_year'),
                vip_address: "192.168.0.22",
                vlogin_system_name: "DESKTOP-A4QMPR3",
                vcreated_by: state?.id ? OrderDetails?.vcreated_by : '',
                dcreated_date1: state?.id ? OrderDetails?.dcreated_date1 : '',
                issueItemList: orderItems
            };

            // console.log("newOrderItem", newOrderItem)

            dispatch(addCartOrderTodo(newOrderItem)).then(() => addOrderFun())
        }
    }

    const addOrderFun = () => {
        // console.log(addCartOrderRes, 'addCartOrderRes')
        if (addCartOrderRes && addCartOrderRes?.status == true) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Order Add Successfull....!",
                showConfirmButton: false,
                timer: 1200
            });
            setOrderItems([])
            setTimeout(() => {
                navigate('../sales-order-list')
            }, 1500);


        } else if (addCartOrderRes && addCartOrderRes?.status == true) {

            Swal.fire({
                title: "Order",
                text: "Something Went Wrong",
                icon: "error"
            });
        }
        else {

            Swal.fire({
                title: "Order",
                text: addCartOrderRes && addCartOrderRes.message,
                icon: "error"
            });
        }
    }

    const detailsResFun = async (res) => {
        console.log("res", res)
        try {
            if (res?.success) {
                await Promise.all([
                    dispatch(CityListTodo(res?.data?.vdespatch_city)).then(() => city_res()),
                    dispatch(PendingAmtTodo()),
                    dispatch(DivisionListTodo())
                ]);
                setDivisionId(res?.data?.idivision_id)
                setDivisionShortName(res?.data?.vdivision_id)
                const ItemsListData = res?.data?.issueItemList?.map(val => (
                    {
                        "iitem_detail_id": val?.id,
                        "iitem_master_id": val?.iitem_master_id,
                        // "vpurchase_order_code": val ? val?.vpurchase_order_code : "",
                        "model_no": val?.model_no,
                        "vcustomer_item_name": val?.vitem_name,
                        "vitem_code": val?.vitem_code,
                        // "vmarketing_item_code": val?.vmarketing_item_code,
                        // "description": val?.description,
                        // "unit": val?.unit,
                        // "irate_per_unit": val?.irate_per_unit,
                        // "irate_per_unit_or": val?.irate_per_unit_or,
                        "fquantity": val?.fquantity,
                        "vtemp_customer": val?.vtemp_customer,
                        "mrate": val?.mrate,
                        // "new_fquantity": val?.msec_qty,
                        "mdiscount_per": val?.mdiscount_per,
                        "mdiscount_value": val?.mdiscount_value,
                        "msgst_tax_per": val?.msgst_tax_per,
                        "mcgst_tax_per": val?.mcgst_tax_per,
                        "migst_tax_per": val?.migst_tax_per,
                        "msgst_tax_value": val?.msgst_tax_value,
                        "mcgst_tax_value": val?.mcgst_tax_per,
                        "migst_tax_value": val?.migst_tax_per,
                        "vitem_remark": val?.vitem_remark,
                        // "ipriority": val?.ipriority,
                        // "isec_unit_id": val?.isec_unit_id,
                        // "mweight": val?.mweight,
                        // "ischeme_id": val?.ischeme_id,
                        // "vprice_list_no": val?.vprice_list_no,
                        "vhsn_code": val?.vhsn_code,
                        // "iware_house_id": val?.iware_house_id,
                        "bsnomain": val?.bsnomain,
                        // "ibusiness_area_id": val?.ibusiness_area_id,
                        // "vtemp_customer": ""
                    }
                ))

                setOrderItems(ItemsListData)
                setLoading(false)
                // setBreakLoading(false)
            } else {
                setLoading(false)
                setOrderItems([])
            }
        } catch (error) {
            setLoading(false)
            setOrderItems([])
        }
    }

    useEffect(() => {

        setLoading(true)
        if (state?.id) {
            dispatch(OrderDetailsTodo({ "code": state?.vpurchase_order_code, "id": state?.id })).then((res) => detailsResFun(res.payload))
        } else {
            dispatch(CityListTodo(OrderDetails?.vdespatch_city)).then(() => city_res())
            dispatch(PendingAmtTodo()).then(() => pending_res())
            dispatch(DivisionListTodo())
            dispatch(OrderDetailsTodo())
            setOrderItems([])

        }


    }, [])

    const pending_res = () => {
        if (PendingAmtRes?.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }



    const totalValue2 = Array.isArray(orderItems) && orderItems.length > 0 ? orderItems.reduce((sum, value) => sum + (
        (value?.fquantity * value?.mrate) + (value?.msgst_tax_per * value?.fquantity * value?.mrate / 100) + (value?.mcgst_tax_per * value?.fquantity * value?.mrate / 100) + (value?.migst_tax_per * value?.fquantity * value?.mrate / 100)
        || 0), 0)
        : 0;

    const textValueTotal = Array.isArray(orderItems) && orderItems.length > 0
        ? orderItems.reduce((sum, value) => sum + (value?.fquantity * value?.mrate || 0), 0)
        : 0;

    const discountValueTotal = Array.isArray(orderItems) && orderItems.length > 0
        ? orderItems.reduce((sum, value) => sum + (value?.fquantity * value?.mrate * value?.mdiscount_value / 100 || 0), 0)
        : 0;

    const calculateTotal = (items, formula) =>
        Array.isArray(items)
            ? items.reduce((sum, value) => sum + (formula(value) || 0), 0)
            : 0;

    const igstTotal = calculateTotal(orderItems, value => value?.migst_tax_per * value?.fquantity * value?.mrate / 100);
    const cgstTotal = calculateTotal(orderItems, value => value?.mcgst_tax_per * value?.fquantity * value?.mrate / 100);
    const sgstTotal = calculateTotal(orderItems, value => value?.msgst_tax_per * value?.fquantity * value?.mrate / 100);

    const drTotalValue = totalValue2 + pendingAmt?.closing_bal
    const crTotalValue = pendingAmt?.closing_bal - totalValue2

    const finalTotalValue = pendingAmt?.vsign === 'Dr.' ? drTotalValue : crTotalValue

    // console.log(finalTotalValue)

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        {loading ?
                            <div className='d-flex justify-content-center'>
                                <Loader />
                            </div> :
                            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <div className='layout_head'>
                                            <h5> Bill To</h5>
                                        </div>
                                        <div className='form_layout content ship_to_sec mt-3'>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p>Dispatch Name</p>
                                                    <span>{localStorage.getItem('vplant_name')}</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <p>Dispatch City</p>
                                                    <span>{localStorage.getItem('vcustomer_plant_city')}</span>
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <p>Dispatch Address</p>
                                                    <span>{localStorage.getItem('vcustomer_plant_address') + " , " + localStorage.getItem('vcustomer_plant_city')}</span>
                                                </div>
                                                <div className="col-md-4 mt-3">
                                                    <p>Dispatch GST No.</p>
                                                    <span>{localStorage.getItem('vdespatach_gst_no')}</span>
                                                </div>
                                                <div className="col-md-4 mt-3">
                                                    <p>Dispatch Pin Code</p>
                                                    <span>{localStorage.getItem('vdespatach_pincode')}</span>
                                                </div>
                                                <div className="col-md-4 mt-3">
                                                    <p>Cust PO Date</p>
                                                    <span>{new Date().toLocaleDateString('en-GB')}</span>
                                                </div>
                                                <div className="col-md-4 mt-3">
                                                    <p>Credit Limit</p>
                                                    <span>{localStorage.getItem('fcredit_limit')}</span>
                                                </div>
                                                <div className="col-md-4 mt-3">
                                                    <p>Outstanding</p>
                                                    <span>{pendingAmt?.closing_bal?.toFixed(2) + ' ' + pendingAmt?.vsign}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={mobileScreen ? "col-md-6 mt-5" : "col-md-6"}>
                                        <div className='layout_head'>
                                            <h5> Ship To</h5>
                                        </div>
                                        <div className='form_layout content mt-3'>
                                            <div className="row">
                                                <div className='d-flex'>
                                                    <Form.Check // prettier-ignore
                                                        type='checkbox'
                                                        className='checkBox'
                                                        // name='approval'
                                                        // checked={checked}
                                                        onChange={(e) => { checkedFun(e.target.checked); }}

                                                    />
                                                    <Form.Label className='form_label ms-2 ' style={{ fontSize: '18px', fontWeight: '600' }}>Same as Bill To</Form.Label>

                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Dispatch Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='name'
                                                            value={values.name}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.name && touched.name ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.name}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Dispatch City</Form.Label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            placeholder=''
                                                            options={city_option}
                                                            name='city'
                                                            className='react_select'
                                                            classNamePrefix="select"
                                                            value={values.city}
                                                            onChange={(e) => {

                                                                setFieldValue('city', e);
                                                                setFieldValue('city_name', e.value == 0 ? '' : e.label)
                                                            }
                                                            }
                                                            onInputChange={(e) => load_city(e)}
                                                            onBlur={handleBlur}
                                                            isLoading={cityLoading}
                                                        />
                                                        {errors.city && touched.city ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.city}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                {values?.city?.value === 0 ? <div className='col-md-6'>
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Dispatch City Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='city_name'
                                                            value={values.city_name}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.city_name && touched.city_name ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.city_name}</span>) : null}

                                                    </Form.Group>
                                                </div> : ''}
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Dispatch Address</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='address'
                                                            value={values.address}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.address && touched.address ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.address}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'> Dispatch GST No.</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='gst_no'
                                                            value={values.gst_no}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.gst_no && touched.gst_no ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.gst_no}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'> Dispatch Pin Code</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='pin_code'
                                                            value={values.pin_code}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.pin_code && touched.pin_code ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.pin_code}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">

                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Cust PO Date</Form.Label>
                                                        <Flatpickr
                                                            className='form_input form-control'
                                                            name='cust_po_date'
                                                            value={values?.cust_po_date}
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "F j, Y",
                                                                dateFormat: 'd-m-Y', // Customize date format as needed
                                                                minDate: '', // Before dates disabled
                                                                maxDate: '', // After dates disabled
                                                                disable: [], // Disable particular date ranges
                                                                mode: "single", //multiple-single-range
                                                                defaultDate: [], // Use today's date as default if none selected
                                                                conjunction: "", // Multiple dates separation
                                                            }}
                                                            onChange={(e) => {
                                                                setFieldValue('cust_po_date', moment(e[0]).format("DD/MM/YYYY"))
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.cust_po_date && touched.cust_po_date ? (
                                                            <span className='text-danger' style={{ fontSize: "15px" }}>
                                                                {errors.cust_po_date}
                                                            </span>
                                                        ) : null}
                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Cust PO Number</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='cust_purchase_order'
                                                            value={values.cust_purchase_order}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.cust_purchase_order && touched.cust_purchase_order ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.cust_purchase_order}</span>) : null}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>File</Form.Label>
                                                        <Form.Control
                                                            type="file"
                                                            className='form_input'
                                                            name='file'
                                                            // value={values.file}
                                                            onChange={(e) => setFieldValue("file", e.currentTarget.files[0])}
                                                            onBlur={handleBlur}
                                                        />
                                                        {/* {errors.address && touched.address ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.address}</span>) : null} */}

                                                    </Form.Group>
                                                </div>
                                                <div className="col-md-12">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Remark</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className='form_input'
                                                            name='remark'
                                                            value={values.remark}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                        />

                                                    </Form.Group>
                                                </div>
                                                {/* <div className="col-md-6" style={{ display: 'none' }}>
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Customer Type</Form.Label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            placeholder='Select Customer Type'
                                                            options={cust_typ_option}
                                                            name='customer_typ'
                                                            isDisabled
                                                            className='react_select'
                                                            classNamePrefix="select"
                                                            defaultValue={cust_typ_option && cust_typ_option.find((option) => option.value == values.customer_typ)}
                                                            // value={values.customer_typ}
                                                            onChange={(e) => {

                                                                setFieldValue('customer_typ', e.value);
                                                            }
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.customer_typ && touched.customer_typ ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.customer_typ}</span>) : null}

                                                    </Form.Group>
                                                </div> */}

                                                {/* <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Sales Order Type</Form.Label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            placeholder='Select SO Type'
                                                            options={so_typ_option}
                                                            name='so_type'
                                                            className='react_select'
                                                            classNamePrefix="select"
                                                            // value={values.so_type}
                                                            defaultValue={so_typ_option?.find((option) => option.value == values.so_type)}
                                                            onChange={(e) => {

                                                                setFieldValue('so_type', e.value);
                                                            }
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.so_type && touched.so_type ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.so_type}</span>) : null}

                                                    </Form.Group>
                                                </div> */}
                                                {/* <div className="col-md-6">
                                                    <Form.Group className="mb-2" controlId="text">
                                                        <Form.Label className='form_label'>Order Type</Form.Label>
                                                        <Select
                                                            closeMenuOnSelect={true}
                                                            placeholder='Select Order Type'
                                                            options={csale_typ_option}
                                                            name='csale_typ'
                                                            className='react_select'
                                                            classNamePrefix="select"
                                                            // value={values.csale_typ}
                                                            defaultValue={csale_typ_option?.find((option) => option.value == values.csale_typ)}
                                                            onChange={(e) => {

                                                                setFieldValue('csale_typ', e.value);
                                                            }
                                                            }
                                                            onBlur={handleBlur}
                                                        />
                                                        {errors.csale_typ && touched.csale_typ ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.csale_typ}</span>) : null}
                                                    </Form.Group>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className=''>
                                    <div className='d-flex justify-content-between align-items-center mt-5 mb-2'>
                                        <div className='layout_head'>
                                            <h5> Add Order</h5>
                                        </div>
                                        {/* <div className='d-flex align-items-center'>
                                            <div style={{ width: '300px' }}>
                                                <Form.Group className="" controlId="text">

                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        placeholder='Select Division'
                                                        options={division_option}
                                                        // name='so_type'
                                                        className='react_select'
                                                        isDisabled={state?.id ? true : false}
                                                        classNamePrefix="select"
                                                        // value={values.so_type}
                                                        defaultValue={division_option?.find((option) => option.value == divisionId)}
                                                        onChange={(e) => {

                                                            setDivisionId(e?.value)
                                                            setDivisionShortName(e?.short_name)
                                                        }
                                                        }
                                                        onBlur={handleBlur}
                                                    />
                                                </Form.Group>
                                            </div> */}
                                        <div>
                                            <Button type='button' onClick={handleModal} variant="" className='ms-2 save_btn'>Add Item</Button><br />

                                        </div>

                                        {/* </div> */}
                                    </div>
                                    <Table responsive striped bordered hover>
                                        <thead >
                                            <tr >
                                                <th >S.NO</th>
                                                <th>ITEM NAME</th>
                                                <th>QTY</th>
                                                {/* <th>SEC. QTY</th> */}
                                                <th>RATE</th>
                                                <th>DISCOUNT</th>
                                                <th>CASE DISCOUNT</th>
                                                <th>TAX. VALUE</th>
                                                <th>SGST</th>
                                                <th>CGST</th>
                                                <th>IGST</th>
                                                <th>TOTAL</th>
                                                <th>ACTION</th>
                                            </tr>
                                        </thead>
                                        {
                                            orderItems && orderItems.length ?


                                                <tbody>
                                                    {orderItems && orderItems.map((value, index) => {
                                                        var mcash_discount_per = 0
                                                        var taxValue = value?.fquantity * value?.mrate
                                                        var discount_val = taxValue * value?.mdiscount_value / 100
                                                        var cash_taxable_value = taxValue - discount_val
                                                        var cash_discount = cash_taxable_value * (mcash_discount_per / 100)
                                                        var cash_dis_val = cash_taxable_value - cash_discount
                                                        var sgstTotl = value?.msgst_tax_per * taxValue / 100
                                                        var cgstTotl = value?.mcgst_tax_per * taxValue / 100
                                                        var igstTotl = value?.migst_tax_per * taxValue / 100
                                                        var totalValue = taxValue + sgstTotl + cgstTotl + igstTotl

                                                        return (
                                                            <>
                                                                <tr>
                                                                    <td>{index + 1}</td>
                                                                    <td>{value?.vcustomer_item_name}</td>
                                                                    <td>{value?.fquantity} </td>
                                                                    {/* <td>{value?.new_fquantity.toFixed(2)} </td> */}
                                                                    <td>{value?.mrate}</td>
                                                                    <td>{discount_val}</td>
                                                                    <td>{cash_discount}</td>
                                                                    <td>{taxValue.toFixed(2)}</td>
                                                                    <td>{sgstTotl.toFixed(2)} ({value?.msgst_tax_per}%) </td>
                                                                    <td>{cgstTotl.toFixed(2)} ({value?.mcgst_tax_per}%) </td>
                                                                    <td>{igstTotl.toFixed(2)} ({value?.migst_tax_per}%) </td>
                                                                    <td>{totalValue.toFixed(2)}  </td>
                                                                    <td style={{ width: "100px" }}>
                                                                        <span className='d-flex '>
                                                                            {/* <LuFileEdit size={20} onClick={() => handleItemEdit(index)} className='edit text-success ms-3' /> */}
                                                                            <LuTrash2 size={20} onClick={() => { delete_items(index); delete_Items2(value) }} className='delete text-danger ms-3' />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    })}
                                                    <td style={{ textAlign: 'center', fontSize: '16px', fontWeight: '600' }} colSpan={4}>Total</td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {discountValueTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {discountValueTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {textValueTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {sgstTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {cgstTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {igstTotal.toFixed(2)}
                                                    </td>
                                                    <td style={{ fontSize: '16px', fontWeight: '600' }}>
                                                        {totalValue2.toFixed(2)}
                                                    </td>
                                                </tbody> :
                                                <tbody>
                                                    <tr>
                                                        <td className='text-center p-5' style={{ fontSize: "18px", color: '#9d9d9d', fontWeight: "500" }} colSpan={12}>Please Select Items</td>
                                                    </tr>
                                                </tbody>
                                        }
                                    </Table>
                                    {orderItems && orderItems.length ? <div className='d-flex justify-content-end'>
                                        <Button type='submit'
                                            variant=""
                                            className='save_btn'
                                            disabled={finalTotalValue > localStorage.getItem('fcredit_limit')}
                                        >
                                            CONFIRM ORDER
                                        </Button>
                                    </div> : ''}
                                </div>
                            </Form>
                        }
                    </div>
                </div >
            </div >
            <AddItem modal={modal} setModal={setModal} divisionId={divisionId} orderItems={orderItems} setOrderItems={setOrderItems} OrderDetails={OrderDetails} />
            {/* <SaveItems saveItems={saveItems} setSaveItems={setSaveItems} itemsData={itemsData} orderItems={orderItems} setOrderItems={setOrderItems} OrderDetails={OrderDetails} /> */}
            {/* <EditItems editItems={editItems} setEditItems={setEditItems} orderItems={orderItems} setOrderItems={setOrderItems} indexValue={indexValue} /> */}
            <ToastContainer />
        </>

    )
}



{/* </Tab> */ }
{/* <Tab eventKey="Attendees" title={<span> Dispatch Address</span>}>

                              

                                    </Tab> */}
{/* </Tabs> */ }


{/* <div className="col-md-6">
                                                <Button type='submit'  variant="" className='save_btn'>SAVE</Button>
                                                </div> */}
{/* <div>
                                                    <Button type='submit' className='btn'>Submit</Button>
                                                </div> */}
{/* <div className="col-md-6">
            
                                                <Form.Group className="mb-2" controlId="text">
                                                    <Form.Label className='form_label'>Cust PO Date</Form.Label>
                                                    <Flatpickr
                                                        className='form_input form-control'
                                                        name='cust_po_date'
                                                        value={values?.cust_po_date}
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "F j, Y",
                                                            dateFormat: 'd-m-Y', // Customize date format as needed
                                                            minDate: '', // Before dates disabled
                                                            maxDate: '', // After dates disabled
                                                            disable: [], // Disable particular date ranges
                                                            mode: "single", //multiple-single-range
                                                            defaultDate: [], // Use today's date as default if none selected
                                                            conjunction: "", // Multiple dates separation
                                                        }}
                                                        onChange={(e) => {
                                                            setFieldValue('cust_po_date', moment(e[0]).format("DD/MM/YYYY"))
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors.cust_po_date && touched.cust_po_date ? (
                                                        <span className='text-danger' style={{ fontSize: "15px" }}>
                                                            {errors.cust_po_date}
                                                        </span>
                                                    ) : null}
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-2" controlId="text">
                                                    <Form.Label className='form_label'>Remark</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className='form_input'
                                                        name='remark'
                                                        value={values.remark}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors.remark && touched.remark ? (<span className='text-danger ' style={{ fontSize: "15px" }} >{errors.remark}</span>) : null}
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Group className="mb-2" controlId="text">
                                                    <Form.Label className='form_label'> Credit Limit</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className='form_input'
                                                        readOnly
                                                        name='credit_limit'
                                                        value={values.credit_limit}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-md-4">
                                                <Form.Group className="mb-2" controlId="text">
                                                    <Form.Label className='form_label'>Outstanding</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        className='form_input'
                                                        readOnly
                                                        name='pending_limit'
                                                        value={values.pending_limit}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                </Form.Group>
                                            </div> */}








// const detailsResFun = (res) => {
//     // console.log("first",res)
//     if (res?.success) {
//         setDivisionId(res?.data?.idivision_id)
//         setDivisionShortName(res?.data?.vdivision_id)
//         const ItemsListData = res?.data?.issueItemList?.map(val => (
//             {
//                 "iitem_detail_id": val?.id,
//                 "iitem_master_id": val?.iitem_master_id,
//                 // "vpurchase_order_code": val ? val?.vpurchase_order_code : "",
//                 "model_no": val?.model_no,
//                 "vcustomer_item_name": val?.vitem_name,
//                 "vitem_code": val?.vitem_code,
//                 // "vmarketing_item_code": val?.vmarketing_item_code,
//                 // "description": val?.description,
//                 // "unit": val?.unit,
//                 // "irate_per_unit": val?.irate_per_unit,
//                 // "irate_per_unit_or": val?.irate_per_unit_or,
//                 "fquantity": val?.fquantity,
//                 "mrate": val?.mrate,
//                 // "new_fquantity": val?.msec_qty,
//                 "mdiscount_per": val?.mdiscount_per,
//                 "mdiscount_value": val?.mdiscount_value,
//                 "msgst_tax_per": val?.msgst_tax_per,
//                 "mcgst_tax_per": val?.mcgst_tax_per,
//                 "migst_tax_per": val?.migst_tax_per,
//                 "msgst_tax_value": val?.msgst_tax_value,
//                 "mcgst_tax_value": val?.mcgst_tax_per,
//                 "migst_tax_value": val?.migst_tax_per,
//                 "vitem_remark": val?.vitem_remark,
//                 // "ipriority": val?.ipriority,
//                 // "isec_unit_id": val?.isec_unit_id,
//                 // "mweight": val?.mweight,
//                 // "ischeme_id": val?.ischeme_id,
//                 // "vprice_list_no": val?.vprice_list_no,
//                 "vhsn_code": val?.vhsn_code,
//                 // "iware_house_id": val?.iware_house_id,
//                 "bsnomain": val?.bsnomain,
//                 // "ibusiness_area_id": val?.ibusiness_area_id,
//                 // "vtemp_customer": ""
//             }
//         ))

//         setOrderItems(ItemsListData)
//         setLoading(false)

//     } else if (res?.success == false) {
//         setLoading(false)
//     } else {
//         setLoading(false)
//     }
// }



//    --------------------------------- CALCULATION ITEMS CODE ----------------------------------

// const totalValue2 = orderItems?.reduce((sum, value) => sum + (
//     (value?.fquantity * value?.mrate) +
//     (value?.msgst_tax_per * value?.fquantity * value?.mrate / 100) +
//     (value?.mcgst_tax_per * value?.fquantity * value?.mrate / 100) +
//     (value?.migst_tax_per * value?.fquantity * value?.mrate)
//     || 0), 0)

// const textValueTotal = orderItems.reduce((sum, value) => sum + (value?.fquantity * value?.mrate || 0), 0)
// const igstTotal = orderItems.reduce((sum, value) => sum + (value?.migst_tax_per * value?.fquantity * value?.mrate / 100 || 0), 0)
// const cgstTotal = orderItems.reduce((sum, value) => sum + (value?.mcgst_tax_per * value?.fquantity * value?.mrate / 100 || 0), 0)
// const sgstTotal = orderItems.reduce((sum, value) => sum + (value?.msgst_tax_per * value?.fquantity * value?.mrate / 100 || 0), 0)
